import React from "react";
import { Container, Row, Col } from "reactstrap";


const PrivacyShortNotice = ({title, aboutText, legalText}) =>
  <Col className="ml-auto mr-auto" md="12">
    <h2 className="title">{title}</h2>
    <p>{aboutText}</p>
    <br />
    <p>{legalText}</p>
    <hr />
    <br />
  </Col>


function TopRangePrivacyNotices() {

  return (
    <Container >

      <div>
        <h2 style={{color: "#dc0000", marginTop: "150px"}}>Уведомление о конфиденциальности (Privacy Notices)</h2>
      </div>

      <Row>
        <PrivacyShortNotice 
          title={'Мобильное приложение "Ока"'}
          aboutText={'Мобильное приложение "Ока" является инструментом отчетности и информирования.'}
          legalText={'АО "ТопРендж" уважает конфиденциальность пользователей, не собирает, не обрабатывает, не хранит и не использует никакие персональные данные пользователей. Пользователи не обязаны предоставлять какие-либо персональные данные (например, имя, адрес электронной почты) компании АО "ТопРендж". Мы стремимся обеспечить максимальную безопасность и комфорт при использовании нашего приложения, поэтому все данные, которые вы вводите или создаете в приложении, остаются исключительно на вашем устройстве и не передаются третьим лицам.'}
        />
        <PrivacyShortNotice 
          title={'Мобильное приложение "ЛифтБиом"'}
          aboutText={'Мобильное приложение "ЛифтБиом" предназначено для демонстрации возможностей интеграционной платформы ЛифтБиом, разработанной компанией АО "Топ Рендж".'}
          legalText={'АО "ТопРендж" уважает конфиденциальность пользователей, не собирает, не обрабатывает, не хранит и не использует никакие персональные данные пользователей. Пользователи не обязаны предоставлять какие-либо персональные данные (например, имя, адрес электронной почты) компании АО "ТопРендж". Мы стремимся обеспечить максимальную безопасность и комфорт при использовании нашего приложения, поэтому все данные, которые вы вводите или создаете в приложении, остаются исключительно на вашем устройстве и не передаются третьим лицам.'}
        />
      </Row>
      
    </Container>
  )
}

export default TopRangePrivacyNotices;